module.exports = __webpack_public_path__ + "static/media/user-ico.f2e01e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/user-ico.png
// module id = 711
// module chunks = 0